import { type FC } from "react";
import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import { Icon } from "@root/shared/components/Icon";
import { colors } from "@root/shared/styles/sprinkles.css";
import * as styles from "./styles.css";

export const GuidanceBoxForReopenUpdate: FC = () => {
  return (
    <GuidanceBox themeColor="pink" className={styles.box}>
      <>
        <p className={styles.about}>
          <span className={styles.iconBox}>
            <Icon name="information" color={colors.Biyo} />
          </span>
          変更のご申請に関して
        </p>
        <p className={styles.detail}>
          利用再開予定日の<span className={styles.dangerText}>7日前</span>まで申し込みが可能です。
        </p>
      </>
    </GuidanceBox>
  );
};
